module.exports = __webpack_public_path__ + "img/chart-line-duotone.bfcc9ddb.svg";